import { addEnvSuffix, ifProd } from 'Utils/env';

export const getCustomerLendingProfileDomain = () => {
  const envVarName = addEnvSuffix('CUSTOMER_LENDING_PROFILE_API');

  return process.env[envVarName];
};

export const getApiDomain = (key) => {
  const keyWitSufix = ifProd(`${key}_PRODUCTION`, addEnvSuffix(key));

  return process.env[keyWitSufix.toUpperCase()];
};

export const formatUrl = (baseUrl, queryParams) => {
  const params = queryParams
    .map(({ key, value } = {}) => key && value && `${key}=${value}`)
    .filter(Boolean)
    .join('&');

  return params.length > 0 ? `${baseUrl}?${params}` : baseUrl;
};
